<div class="box">
    <ng-container>
        <div class="rows">
            <div class="row">
                <h2 checkoutCy="sim_title" class="title is-level-5">Je choisis ma SIM</h2>
                <p class="text is-level-2">
                    @if (isRenew) {
                    @if (simContext?.isCompatible) {
                    Votre SIM actuelle est compatible avec ce téléphone. Vous pouvez commander une nouvelle SIM
                    si vous le souhaitez.
                    } @else {
                    Votre SIM actuelle est incompatible avec ce téléphone. Nous ajoutons dans votre panier une
                    SIM compatible.
                    }
                    } @else {
                    Essentielle pour profiter de mon forfait.
                    }
                </p>
            </div>
            <div class="row">
                @defer (when sims?.length > 0) {
                @if (isRenew) {
                <div class="radio-tile is-horizontal" [ngClass]="{ 'is-loading': isLoading && choosenSim }">
                    <input data-tc-action="Clic_selection" data-tc-categorie="Selection_SIM"
                        attr.data-tc-clic="Conserver_ma_SIM" [checkoutCy]="'renew'" [checked]="isRenew && !selectedSim"
                        (click)="onChoice($event, keepSim)" id="radio-{{ 'renew' }}" type="radio" name="radio-tile" />
                    <label htmlFor="radio-{{ 'renew' }}" class="radio-label" data-tabIndex="{{ 0 }}">
                        <span>
                            <span class="radio-title">Conserver ma SIM</span>
                            @if (simContext?.isCompatible) {
                            <span class="radio-description">Recommandé pour vous</span>
                            }
                        </span>
                    </label>
                </div>
                }

                @for (sim of sims; track sim.gencode; let i = $index) {
                <div checkoutCy="{{ sim.type }}-{{ sim.gencode }}" class="radio-tile is-horizontal"
                    [ngClass]="isLoading && choosenSim?.gencode !== sim?.gencode ? 'is-loading' : 'is-loaded'">
                    <input [disabled]="isSummerEditionPlan && sim.type === SIM_TYPES.SIM"
                        [checked]="selectedSim?.gencode === sim.gencode" (click)="onChoice($event, sim)"
                        id="radio-{{ sim.gencode }}" type="radio" name="radio-tile" />
                    <label htmlFor="radio-{{ sim.gencode }}" class="radio-label sim" data-tabIndex="{{ i }}">
                        @if (sim.type === SIM_TYPES.SIM) {
                        <span>
                            <span class="radio-title">
                                {{
                                isRenew && !simContext?.isCompatible
                                ? 'Nouvelle carte SIM'
                                : 'Carte SIM'
                                }}
                            </span>
                            <span class="radio-description">Une carte physique.</span>
                        </span>
                        <span>
                            @if (sim.price === 0) {
                            <span class="test is-level-1 has-text-weight-semibold">Gratuit</span>
                            } @else {
                            <trg-price [isInlined]="true" [price]="sim.price"
                                [size]="'text is-level-1 has-text-weight-semibold is-marginless'"></trg-price>
                            }
                        </span>
                        } @else {
                        <span>
                            <span class="radio-title">
                                {{ isRenew && !simContext?.isCompatible ? 'Nouvelle eSIM' : 'eSIM' }}
                            </span>
                            <span class="radio-description is-flex is-multiline">
                                <span>Une carte SIM dématérialisée.&nbsp;</span>
                                <span>Plus de carte à insérer.</span>
                            </span>
                        </span>
                        <span>
                            @if (sim.price === 0) {
                            <span class="test is-level-1 has-text-weight-semibold">Gratuit</span>
                            } @else {
                            <trg-price [isInlined]="true" [price]="sim.price"
                                [size]="'text is-level-1 has-text-weight-semibold is-marginless'"></trg-price>
                            }
                        </span>
                        }
                    </label>
                </div>
                }
                } @placeholder (minimum 1000ms) {
                @if (isRenew) {
                <div class="radio-tile is-horizontal is-loading">
                    <input [checked]="false" id="radio-loading-rnw-1" type="radio" name="radio-tile" />
                    <label htmlFor="radio-loading" class="radio-label" data-tabIndex="{{ 0 }}">
                        <span>
                            <span class="radio-title">Conserver ma SIM</span>
                            <span class="radio-description">Recommandé pour vous</span>
                        </span>
                    </label>
                </div>
                <div class="radio-tile is-horizontal is-loading">
                    <input [checked]="false" id="radio-loading-rnw-2" type="radio" name="radio-tile" />
                    <label htmlFor="radio-loading" class="radio-label" data-tabIndex="{{ 0 }}">
                        <span>
                            <span class="radio-title">Conserver ma SIM</span>
                            <span class="radio-description">Recommandé pour vous</span>
                        </span>
                    </label>
                </div>
                } @else {
                <div class="radio-tile is-horizontal is-loading">
                    <input [checked]="false" id="radio-loading" type="radio" name="radio-tile" />
                    <label htmlFor="radio-loading" class="radio-label" data-tabIndex="{{ 0 }}">
                        <span>
                            <span class="radio-title">Conserver ma SIM</span>
                            <span class="radio-description">Recommandé pour vous</span>
                        </span>
                    </label>
                </div>
                }
                } @error {}
            </div>
            @if (incompatibleSimType) {
                <checkout-sim-incompatibility-alert
                    [simType]="incompatibleSimType"
                    (compatibilityLinkClick)="showCompatibilityModal()">
                </checkout-sim-incompatibility-alert>
            }
        </div>
    </ng-container>
</div>
